import { Plus } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const AddMemberDialog = ({ children, isDisabled = false }: React.PropsWithChildren<{ isDisabled?: boolean }>) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="sm" disabled={isDisabled}>
          <Plus /> Add members
        </Button>
      </DialogTrigger>
      <DialogContent className="flex flex-col h-screen max-w-full sm:max-w-full rounded-none bg-muted p-0">
        <DialogHeader className="hidden">
          <DialogTitle>Manage team members</DialogTitle>
          <DialogDescription>Manage team members</DialogDescription>
        </DialogHeader>
        {children}
        <DialogFooter className="shrink-0 px-10 pb-6">
          <DialogClose asChild>
            <Button>Done</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddMemberDialog;
